import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ContactInformation from "./sections/ContactInformation";
import GlossyBottomNavigation from "./sections/GlossyBottomNavigation";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ContactInformation />
      <GlossyBottomNavigation />
      <Footer />
    </div>;
}